import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelText as _vModelText, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "action-toolbar"
};
const _hoisted_2 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_3 = {
  class: "data-table-shell"
};
const _hoisted_4 = {
  key: 0,
  class: "p-4"
};
const _hoisted_5 = {
  class: "space-y-4"
};
const _hoisted_6 = {
  key: 1,
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_7 = {
  class: "data-table min-w-[1024px]"
};
const _hoisted_8 = {
  class: "data-table-head"
};
const _hoisted_9 = {
  class: "data-table-th text-left w-10"
};
const _hoisted_10 = {
  class: "data-table-body"
};
const _hoisted_11 = {
  class: "data-table-td"
};
const _hoisted_12 = ["value", "disabled"];
const _hoisted_13 = {
  class: "data-table-td"
};
const _hoisted_14 = {
  class: "data-table-cell-title"
};
const _hoisted_15 = {
  class: "data-table-cell-meta max-w-xs truncate"
};
const _hoisted_16 = {
  class: "data-table-td"
};
const _hoisted_17 = {
  class: "data-table-td"
};
const _hoisted_18 = {
  class: "data-table-td"
};
const _hoisted_19 = {
  class: "flex items-center gap-1 flex-wrap"
};
const _hoisted_20 = {
  class: "data-table-td"
};
const _hoisted_21 = {
  class: "data-table-td"
};
const _hoisted_22 = {
  class: "text-sm text-slate-600"
};
const _hoisted_23 = {
  class: "text-slate-900"
};
const _hoisted_24 = {
  class: "text-green-600"
};
const _hoisted_25 = {
  key: 0,
  class: "text-xs text-slate-400 ml-1"
};
const _hoisted_26 = {
  class: "data-table-td"
};
const _hoisted_27 = {
  class: "text-sm text-slate-500"
};
const _hoisted_28 = {
  key: 0
};
const _hoisted_29 = {
  key: 1,
  class: "text-blue-600"
};
const _hoisted_30 = {
  key: 2,
  class: "text-slate-400"
};
const _hoisted_31 = {
  class: "data-table-td data-table-sticky-right data-table-sticky-action"
};
const _hoisted_32 = {
  class: "flex items-center gap-1"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["onClick"];
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
  key: 0
};
const _hoisted_38 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_39 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_40 = {
  class: "p-6 max-h-[70vh] overflow-y-auto"
};
const _hoisted_41 = {
  class: "space-y-4"
};
const _hoisted_42 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_43 = {
  class: "flex flex-wrap gap-3"
};
const _hoisted_44 = ["value"];
const _hoisted_45 = {
  class: "text-sm"
};
const _hoisted_46 = {
  class: "mt-2"
};
const _hoisted_47 = {
  class: "form-switch"
};
const _hoisted_48 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_49 = {
  class: "mt-4"
};
const _hoisted_50 = {
  class: "form-switch"
};
const _hoisted_51 = {
  key: 0,
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_52 = {
  class: "text-sm font-medium text-slate-700 mb-3"
};
const _hoisted_53 = {
  key: 0,
  class: "mb-3"
};
const _hoisted_54 = {
  key: 1,
  class: "mb-3"
};
const _hoisted_55 = {
  key: 2,
  class: "mb-3"
};
const _hoisted_56 = {
  key: 3,
  class: "mb-3"
};
const _hoisted_57 = {
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_58 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_59 = {
  key: 0,
  class: "mt-3"
};
const _hoisted_60 = {
  key: 1,
  class: "mt-3"
};
const _hoisted_61 = {
  class: "form-switch"
};
const _hoisted_62 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3"
};
const _hoisted_63 = ["disabled"];
const _hoisted_64 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_65 = {
  class: "p-6 max-h-[70vh] overflow-y-auto"
};
const _hoisted_66 = {
  class: "space-y-4"
};
const _hoisted_67 = {
  class: "flex items-center gap-3"
};
const _hoisted_68 = {
  class: "text-lg font-semibold text-slate-800"
};
const _hoisted_69 = {
  class: "text-sm text-slate-500 mt-1"
};
const _hoisted_70 = {
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_71 = {
  key: 0,
  class: "p-4 bg-slate-50 rounded-lg prose prose-sm max-w-none text-slate-800"
};
const _hoisted_72 = {
  key: 1,
  class: "p-4 bg-slate-50 rounded-lg text-sm text-slate-800 whitespace-pre-wrap"
};
const _hoisted_73 = {
  class: "grid grid-cols-2 gap-4 border-t border-slate-200 pt-4"
};
const _hoisted_74 = {
  class: "text-sm text-slate-800 mt-1"
};
const _hoisted_75 = {
  class: "text-sm text-slate-800 mt-1"
};
const _hoisted_76 = {
  class: "text-sm text-slate-800 mt-1"
};
const _hoisted_77 = {
  class: "text-sm text-slate-800 mt-1"
};
const _hoisted_78 = {
  key: 0,
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_79 = {
  class: "text-sm text-slate-600 space-y-1"
};
const _hoisted_80 = {
  key: 0
};
const _hoisted_81 = {
  key: 1
};
const _hoisted_82 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end"
};
const _hoisted_83 = {
  class: "mb-4"
};
const _hoisted_84 = {
  key: 0,
  class: "mb-4"
};
const _hoisted_85 = {
  class: "block text-sm font-medium text-slate-700 mb-1"
};
const _hoisted_86 = {
  key: 0
};
const _hoisted_87 = {
  key: 1
};
const _hoisted_88 = {
  key: 2
};
const _hoisted_89 = {
  key: 3
};
const _hoisted_90 = {
  class: "flex items-center justify-end gap-3"
};
const _hoisted_91 = ["disabled"];
import { ref, reactive, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import RichTextEditor from '@/components/RichTextEditor.vue';
import { isHtmlContent, stripHtmlTags } from '@/utils/htmlContent';
import { formatDateTimeText } from '@/utils/dateFormat';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import AppModal from '@/components/AppModal.vue';
import { getNotificationList, getNotificationDetail, createNotification, updateNotification, deleteNotification, updatePublishStatus } from '@/api/notification';

// 引入选择器组件
import FranchiseeSelector from '@/components/FranchiseeSelector/index.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import RoleSelector from './components/RoleSelector/index.vue';
import DeptSelector from '@/components/DeptSelector/index.vue';
import UserSelector from '@/components/UserSelector/index.vue';
export default {
  __name: 'NotificationManagement',
  setup(__props) {
    const loading = ref(false);
    const saving = ref(false);
    const publishing = ref(false);
    const showModal = ref(false);
    const showDetailModal = ref(false);
    const showPublishModal = ref(false);
    const isEdit = ref(false);
    const currentDetail = ref(null);
    const currentNotification = ref(null);
    const notificationList = ref([]);
    const selectedList = ref([]);
    const selectAll = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(10);
    const total = ref(0);
    const totalPages = ref(1);
    const searchForm = reactive({
      type: '',
      priority: '',
      publishStatus: ''
    });
    const formData = reactive({
      id: null,
      type: 'SYSTEM',
      title: '',
      summary: '',
      content: '',
      priority: 0,
      needPush: false,
      pushChannels: [],
      scheduleTime: '',
      publishNow: false,
      targetType: 'ALL_USER',
      tenantIds: [],
      roleIds: [],
      deptIds: [],
      userIds: [],
      link: {
        linkType: '',
        businessId: '',
        webUrl: '',
        webNewWindow: false
      }
    });
    const publishTarget = reactive({
      targetType: 'ALL_USER',
      tenantIds: [],
      roleIds: [],
      deptIds: [],
      userIds: []
    });

    // 目标用户类型选项
    const targetTypeOptions = [{
      value: 'ALL_USER',
      label: '全体用户'
    }, {
      value: 'TENANT',
      label: '指定加盟商'
    }, {
      value: 'ROLE',
      label: '指定角色'
    }, {
      value: 'DEPT',
      label: '指定部门'
    }, {
      value: 'USER_LIST',
      label: '指定用户'
    }];
    function getTargetTypeLabel(type) {
      const opt = targetTypeOptions.find(o => o.value === type);
      return opt ? opt.label : '';
    }

    // 从对象数组中提取ID列表
    function extractIds(arr) {
      if (!arr || !Array.isArray(arr)) return [];
      return arr.map(item => {
        if (typeof item === 'object' && item.id != null) {
          return item.id;
        }
        return item;
      });
    }
    function getSelectedCount() {
      switch (formData.targetType) {
        case 'TENANT':
          return formData.tenantIds?.length || 0;
        case 'ROLE':
          return formData.roleIds?.length || 0;
        case 'DEPT':
          return formData.deptIds?.length || 0;
        case 'USER_LIST':
          return formData.userIds?.length || 0;
        default:
          return 0;
      }
    }
    const pushChannelOptions = [{
      value: 'EMAIL',
      label: '邮件'
    }, {
      value: 'SMS',
      label: '短信'
    }, {
      value: 'DINGTALK',
      label: '钉钉'
    }];
    function getTypeClass(type) {
      const classMap = {
        APPROVAL: 'status-badge is-warning',
        TASK: 'status-badge is-purple',
        SYSTEM: 'status-badge is-info',
        CUSTOM: 'status-badge is-success'
      };
      return classMap[type] || 'status-badge is-neutral';
    }
    function getTypeLabel(type) {
      const labelMap = {
        APPROVAL: '审批通知',
        TASK: '任务通知',
        SYSTEM: '系统通知',
        CUSTOM: '自定义通知'
      };
      return labelMap[type] || type;
    }
    function getPriorityClass(priority) {
      const classMap = {
        0: 'status-badge is-neutral',
        1: 'status-badge is-warning',
        2: 'status-badge is-danger'
      };
      return classMap[priority] || 'status-badge is-neutral';
    }
    function getPriorityDotClass(priority) {
      const classMap = {
        0: 'bg-slate-400',
        1: 'bg-amber-500',
        2: 'bg-red-500'
      };
      return classMap[priority] || 'bg-slate-400';
    }
    function getPriorityLabel(priority) {
      const labelMap = {
        0: '普通',
        1: '重要',
        2: '紧急'
      };
      return labelMap[priority] || '普通';
    }
    function getChannelLabel(channel) {
      const labelMap = {
        EMAIL: '邮件',
        SMS: '短信',
        DINGTALK: '钉钉',
        inapp: '站内信'
      };
      return labelMap[channel] || channel;
    }
    function getPushChannels(channels) {
      if (!channels) return [];
      if (Array.isArray(channels)) return channels;
      return channels.split(',').filter(c => c);
    }
    function handleSelectAll() {
      if (selectAll.value) {
        selectedList.value = notificationList.value.filter(item => item.publishStatus !== 'PUBLISHED').map(item => item.id);
      } else {
        selectedList.value = [];
      }
    }
    async function loadNotifications() {
      try {
        loading.value = true;
        const params = {
          pageNum: currentPage.value,
          pageSize: pageSize.value
        };
        if (searchForm.type) params.type = searchForm.type;
        if (searchForm.priority !== '') params.priority = parseInt(searchForm.priority);
        if (searchForm.publishStatus !== '') params.publishStatus = parseInt(searchForm.publishStatus);
        const res = await getNotificationList(params);
        notificationList.value = res.records || [];
        total.value = res.total || 0;
        totalPages.value = res.pages || 1;
      } catch (error) {
        console.error('加载通知列表失败:', error);
        ElMessage.error(error.message || '加载通知列表失败');
      } finally {
        loading.value = false;
      }
    }
    function handleSearch() {
      currentPage.value = 1;
      loadNotifications();
    }
    function resetSearch() {
      searchForm.type = '';
      searchForm.priority = '';
      searchForm.publishStatus = '';
      handleSearch();
    }
    function handlePageChange(page) {
      currentPage.value = page;
      loadNotifications();
    }
    function handlePageSizeChange(size) {
      pageSize.value = size;
      currentPage.value = 1;
      loadNotifications();
    }
    function openNotificationModal(notification = null) {
      if (notification) {
        isEdit.value = true;
        formData.id = notification.id;
        formData.type = notification.type;
        formData.title = notification.title;
        formData.summary = notification.summary || '';
        formData.content = notification.content;
        formData.priority = notification.priority;
        formData.needPush = notification.needPush || false;
        formData.pushChannels = getPushChannels(notification.pushChannels);
        formData.scheduleTime = notification.scheduleTime ? notification.scheduleTime.slice(0, 16) : '';
        formData.targetType = notification.target?.targetType || 'ALL_USER';
        formData.tenantIds = notification.target?.tenantIds || [];
        formData.roleIds = notification.target?.roleIds || [];
        formData.deptIds = notification.target?.deptIds || [];
        formData.userIds = notification.target?.userIds || [];
        formData.link = {
          linkType: notification.linkType || '',
          businessId: notification.businessId || '',
          webUrl: notification.webUrl || '',
          webNewWindow: notification.webNewWindow || false
        };
      } else {
        isEdit.value = false;
        formData.id = null;
        formData.type = 'SYSTEM';
        formData.title = '';
        formData.summary = '';
        formData.content = '';
        formData.priority = 0;
        formData.needPush = false;
        formData.pushChannels = [];
        formData.scheduleTime = '';
        formData.publishNow = false;
        formData.targetType = 'ALL_USER';
        formData.tenantIds = [];
        formData.roleIds = [];
        formData.deptIds = [];
        formData.userIds = [];
        formData.link = {
          linkType: '',
          businessId: '',
          webUrl: '',
          webNewWindow: false
        };
      }
      showModal.value = true;
    }
    function closeModal() {
      showModal.value = false;
    }
    async function handleSave() {
      if (!formData.title.trim()) {
        ElMessage.warning('请输入通知标题');
        return;
      }
      if (!formData.content || !formData.content.trim()) {
        ElMessage.warning('请输入通知内容');
        return;
      }
      // 验证目标用户选择
      if (formData.targetType !== 'ALL_USER' && getSelectedCount() === 0) {
        ElMessage.warning(`请至少选择一个${getTargetTypeLabel(formData.targetType)}`);
        return;
      }
      try {
        saving.value = true;
        const data = {
          type: formData.type,
          publishStatus: formData.publishNow ? 1 : 0,
          title: formData.title,
          content: formData.content,
          summary: formData.summary,
          priority: parseInt(formData.priority),
          needPush: formData.needPush,
          pushChannels: formData.pushChannels.join(','),
          scheduleTime: formData.scheduleTime ? new Date(formData.scheduleTime).toISOString() : '',
          target: {
            targetType: formData.targetType,
            tenantIds: formData.targetType === 'TENANT' ? extractIds(formData.tenantIds) : [],
            roleIds: formData.targetType === 'ROLE' ? extractIds(formData.roleIds) : [],
            deptIds: formData.targetType === 'DEPT' ? extractIds(formData.deptIds) : [],
            userIds: formData.targetType === 'USER_LIST' ? extractIds(formData.userIds) : []
          },
          link: {
            linkType: formData.link.linkType || null,
            businessId: formData.link.businessId || null,
            webPath: formData.link.webUrl || null,
            webNewWindow: formData.link.webNewWindow || false
          }
        };
        if (isEdit.value) {
          await updateNotification(formData.id, data);
          ElMessage.success('更新成功');
        } else {
          await createNotification(data);
          ElMessage.success('创建成功');
        }
        closeModal();
        loadNotifications();
      } catch (error) {
        console.error('保存通知失败:', error);
        ElMessage.error(error.message || '保存通知失败');
      } finally {
        saving.value = false;
      }
    }
    async function handleDelete(id) {
      try {
        await ElMessageBox.confirm('确定要删除该通知吗？删除后无法恢复。', '确认删除', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await deleteNotification(id);
        ElMessage.success('删除成功');
        loadNotifications();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除通知失败:', error);
          ElMessage.error(error.message || '删除通知失败');
        }
      }
    }
    async function handleBatchDelete() {
      if (selectedList.value.length === 0) {
        ElMessage.warning('请选择要删除的通知');
        return;
      }
      try {
        await ElMessageBox.confirm(`确定要删除选中的 ${selectedList.value.length} 条通知吗？`, '确认删除', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await Promise.all(selectedList.value.map(id => deleteNotification(id)));
        ElMessage.success('批量删除成功');
        selectedList.value = [];
        selectAll.value = false;
        loadNotifications();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('批量删除失败:', error);
          ElMessage.error(error.message || '批量删除失败');
        }
      }
    }
    function handlePublish(notification) {
      currentNotification.value = notification;
      publishTarget.targetType = 'ALL_USER';
      publishTarget.tenantIds = [];
      publishTarget.roleIds = [];
      publishTarget.deptIds = [];
      publishTarget.userIds = [];
      showPublishModal.value = true;
    }
    async function confirmPublish() {
      // 验证目标用户选择
      if (publishTarget.targetType !== 'ALL_USER') {
        const hasSelection = publishTarget.targetType === 'TENANT' && publishTarget.tenantIds?.length > 0 || publishTarget.targetType === 'ROLE' && publishTarget.roleIds?.length > 0 || publishTarget.targetType === 'DEPT' && publishTarget.deptIds?.length > 0 || publishTarget.targetType === 'USER_LIST' && publishTarget.userIds?.length > 0;
        if (!hasSelection) {
          ElMessage.warning(`请至少选择一个${getTargetTypeLabel(publishTarget.targetType)}`);
          return;
        }
      }
      try {
        publishing.value = true;
        await updatePublishStatus(currentNotification.value.id, {
          id: currentNotification.value.id,
          publishStatus: 1,
          target: {
            targetType: publishTarget.targetType,
            tenantIds: publishTarget.targetType === 'TENANT' ? extractIds(publishTarget.tenantIds) : [],
            roleIds: publishTarget.targetType === 'ROLE' ? extractIds(publishTarget.roleIds) : [],
            deptIds: publishTarget.targetType === 'DEPT' ? extractIds(publishTarget.deptIds) : [],
            userIds: publishTarget.targetType === 'USER_LIST' ? extractIds(publishTarget.userIds) : []
          }
        });
        ElMessage.success('发布成功');
        showPublishModal.value = false;
        loadNotifications();
      } catch (error) {
        console.error('发布通知失败:', error);
        ElMessage.error(error.message || '发布通知失败');
      } finally {
        publishing.value = false;
      }
    }
    async function viewDetail(notification) {
      try {
        const res = await getNotificationDetail(notification.id);
        currentDetail.value = res;
        showDetailModal.value = true;
      } catch (error) {
        console.error('获取通知详情失败:', error);
        ElMessage.error(error.message || '获取通知详情失败');
      }
    }
    onMounted(() => {
      loadNotifications();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_text = _resolveComponent("el-text");
      const _directive_safe_html = _resolveDirective("safe-html");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[34] || (_cache[34] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "通知管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "创建和管理系统通知消息")])])], -1)]))]),
        default: _withCtx(() => [selectedList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", {
          onClick: handleBatchDelete,
          class: "btn-danger-secondary"
        }, [_cache[35] || (_cache[35] = _createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
        })], -1)), _createTextVNode(" 删除选中 (" + _toDisplayString(selectedList.value.length) + ") ", 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": "",
          "refresh-loading": loading.value,
          onRefresh: loadNotifications
        }, {
          searchActionsLeading: _withCtx(() => [_createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = $event => openNotificationModal()),
            class: "btn-primary"
          }, [...(_cache[36] || (_cache[36] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 发布通知 ", -1)]))])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            onClick: handleSearch,
            class: "btn-primary"
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            onClick: resetSearch,
            class: "btn-secondary"
          }, "重置")]),
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: searchForm.type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchForm.type = $event),
            placeholder: "请选择类型",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部类型",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "审批通知",
              value: "APPROVAL"
            }), _createVNode(_component_el_option, {
              label: "任务通知",
              value: "TASK"
            }), _createVNode(_component_el_option, {
              label: "系统通知",
              value: "SYSTEM"
            }), _createVNode(_component_el_option, {
              label: "自定义通知",
              value: "CUSTOM"
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: searchForm.priority,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchForm.priority = $event),
            placeholder: "请选择优先级",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部优先级",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "普通",
              value: "0"
            }), _createVNode(_component_el_option, {
              label: "重要",
              value: "1"
            }), _createVNode(_component_el_option, {
              label: "紧急",
              value: "2"
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: searchForm.publishStatus,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchForm.publishStatus = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "草稿",
              value: "0"
            }), _createVNode(_component_el_option, {
              label: "已发布",
              value: "1"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_3, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, n => {
          return _createElementVNode("div", {
            key: n,
            class: "flex items-center gap-4 p-4 border-b border-slate-100"
          }, [...(_cache[37] || (_cache[37] = [_createElementVNode("div", {
            class: "w-4 h-4 bg-slate-200 rounded"
          }, null, -1), _createElementVNode("div", {
            class: "w-20 h-6 bg-slate-200 rounded"
          }, null, -1), _createElementVNode("div", {
            class: "flex-1 h-6 bg-slate-200 rounded"
          }, null, -1), _createElementVNode("div", {
            class: "w-24 h-6 bg-slate-200 rounded"
          }, null, -1)]))]);
        }), 64))])])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("table", _hoisted_7, [_createElementVNode("thead", _hoisted_8, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_9, [_withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => selectAll.value = $event),
          onChange: handleSelectAll,
          class: "form-check"
        }, null, 544), [[_vModelCheckbox, selectAll.value]])]), _cache[38] || (_cache[38] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "通知标题", -1)), _cache[39] || (_cache[39] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "类型", -1)), _cache[40] || (_cache[40] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "优先级", -1)), _cache[41] || (_cache[41] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "推送渠道", -1)), _cache[42] || (_cache[42] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态", -1)), _cache[43] || (_cache[43] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "接收/已读", -1)), _cache[44] || (_cache[44] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "发送时间", -1)), _cache[45] || (_cache[45] = _createElementVNode("th", {
          class: "data-table-th text-left data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作", -1))])]), _createElementVNode("tbody", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notificationList.value, item => {
          return _openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_11, [_withDirectives(_createElementVNode("input", {
            type: "checkbox",
            value: item.id,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => selectedList.value = $event),
            class: "form-check",
            disabled: item.publishStatus === 'PUBLISHED'
          }, null, 8, _hoisted_12), [[_vModelCheckbox, selectedList.value]])]), _createElementVNode("td", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(item.summary || _unref(stripHtmlTags)(item.content)), 1)]), _createElementVNode("td", _hoisted_16, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", getTypeClass(item.type)])
          }, _toDisplayString(item.typeDesc || getTypeLabel(item.type)), 3)]), _createElementVNode("td", _hoisted_17, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", getPriorityClass(item.priority)])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1", getPriorityDotClass(item.priority)])
          }, null, 2), _createTextVNode(" " + _toDisplayString(item.priorityDesc || getPriorityLabel(item.priority)), 1)], 2)]), _createElementVNode("td", _hoisted_18, [_createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPushChannels(item.pushChannels), channel => {
            return _openBlock(), _createElementBlock("span", {
              key: channel,
              class: "data-table-inline-tag"
            }, _toDisplayString(getChannelLabel(channel)), 1);
          }), 128))])]), _createElementVNode("td", _hoisted_20, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", item.publishStatus === 'PUBLISHED' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'])
          }, _toDisplayString(item.publishStatusDesc || (item.publishStatus === 'PUBLISHED' ? '已发布' : '草稿')), 3)]), _createElementVNode("td", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, _toDisplayString(item.totalReceivers || 0), 1), _cache[46] || (_cache[46] = _createElementVNode("span", {
            class: "text-slate-400 mx-1"
          }, "/", -1)), _createElementVNode("span", _hoisted_24, _toDisplayString(item.readCount || 0), 1), item.readRate ? (_openBlock(), _createElementBlock("span", _hoisted_25, "(" + _toDisplayString(item.readRate) + "%)", 1)) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_26, [_createElementVNode("div", _hoisted_27, [item.sentTime ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(formatDateTimeText)(item.sentTime)), 1)) : item.scheduleTime ? (_openBlock(), _createElementBlock("div", _hoisted_29, " 定时: " + _toDisplayString(_unref(formatDateTimeText)(item.scheduleTime)), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_30, "-"))])]), _createElementVNode("td", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("button", {
            onClick: $event => viewDetail(item),
            class: "table-action-button is-primary",
            title: "查看详情",
            "aria-label": "查看详情"
          }, [...(_cache[47] || (_cache[47] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_33), item.publishStatus === 'DRAFT' ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: $event => openNotificationModal(item),
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑"
          }, [...(_cache[48] || (_cache[48] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_34)) : _createCommentVNode("", true), item.publishStatus === 'DRAFT' ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: $event => handlePublish(item),
            class: "table-action-button is-success",
            title: "发布",
            "aria-label": "发布"
          }, [...(_cache[49] || (_cache[49] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
          })], -1)]))], 8, _hoisted_35)) : _createCommentVNode("", true), item.publishStatus === 'DRAFT' ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: $event => handleDelete(item.id),
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除"
          }, [...(_cache[50] || (_cache[50] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_36)) : _createCommentVNode("", true)])])]);
        }), 128)), notificationList.value.length === 0 && !loading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [...(_cache[51] || (_cache[51] = [_createElementVNode("td", {
          colspan: "9",
          class: "data-table-empty text-slate-500"
        }, "暂无通知数据", -1)]))])) : _createCommentVNode("", true)])])]))]), total.value > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          current: currentPage.value,
          size: pageSize.value,
          total: total.value,
          pages: totalPages.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["current", "size", "total", "pages"])) : _createCommentVNode("", true)]), _createVNode(AppModal, {
          visible: showModal.value,
          size: "2xl",
          scrollable: false,
          onClose: closeModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_createElementVNode("h3", _hoisted_39, _toDisplayString(isEdit.value ? '编辑通知' : '发布通知'), 1), _createElementVNode("button", {
            onClick: closeModal,
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
          }, [...(_cache[52] || (_cache[52] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_40, [_createElementVNode("form", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", null, [_cache[53] || (_cache[53] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 通知类型 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_select, {
            modelValue: formData.type,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.type = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "审批通知",
              value: "APPROVAL"
            }), _createVNode(_component_el_option, {
              label: "任务通知",
              value: "TASK"
            }), _createVNode(_component_el_option, {
              label: "系统通知",
              value: "SYSTEM"
            }), _createVNode(_component_el_option, {
              label: "自定义通知",
              value: "CUSTOM"
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[54] || (_cache[54] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 优先级 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_select, {
            modelValue: formData.priority,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formData.priority = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "普通",
              value: "0"
            }), _createVNode(_component_el_option, {
              label: "重要",
              value: "1"
            }), _createVNode(_component_el_option, {
              label: "紧急",
              value: "2"
            })]),
            _: 1
          }, 8, ["modelValue"])])]), _createElementVNode("div", null, [_cache[55] || (_cache[55] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 通知标题 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formData.title = $event),
            type: "text",
            placeholder: "请输入通知标题",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, formData.title]])]), _createElementVNode("div", null, [_cache[56] || (_cache[56] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, " 通知摘要 ", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formData.summary = $event),
            type: "text",
            placeholder: "请输入通知摘要，用于列表展示",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, formData.summary]])]), _createElementVNode("div", null, [_cache[57] || (_cache[57] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode(" 通知内容 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(RichTextEditor, {
            modelValue: formData.content,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => formData.content = $event),
            placeholder: "请输入通知内容...",
            "min-height": "250px",
            "upload-module": "notification"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[60] || (_cache[60] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, " 推送渠道 ", -1)), _createElementVNode("div", _hoisted_43, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(pushChannelOptions, channel => {
            return _createElementVNode("label", {
              key: channel.value,
              class: _normalizeClass(["flex items-center gap-2 px-3 py-2 border rounded-lg cursor-pointer transition-colors", formData.pushChannels.includes(channel.value) ? 'border-primary-500 bg-primary-50' : 'border-slate-300 hover:bg-slate-50'])
            }, [_withDirectives(_createElementVNode("input", {
              type: "checkbox",
              value: channel.value,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => formData.pushChannels = $event),
              class: "form-check"
            }, null, 8, _hoisted_44), [[_vModelCheckbox, formData.pushChannels]]), _createElementVNode("span", _hoisted_45, _toDisplayString(channel.label), 1)], 2);
          }), 64))]), _createElementVNode("div", _hoisted_46, [_createElementVNode("label", _hoisted_47, [_withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => formData.needPush = $event),
            class: "form-switch-input"
          }, null, 512), [[_vModelCheckbox, formData.needPush]]), _cache[58] || (_cache[58] = _createElementVNode("span", {
            class: "form-switch-track"
          }, null, -1)), _cache[59] || (_cache[59] = _createElementVNode("span", {
            class: "ml-3 text-sm text-slate-700"
          }, "同时发送推送通知", -1))])])]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", null, [_cache[61] || (_cache[61] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, " 目标用户 ", -1)), _createVNode(_component_el_select, {
            modelValue: formData.targetType,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => formData.targetType = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(targetTypeOptions, opt => {
              return _createVNode(_component_el_option, {
                key: opt.value,
                label: opt.label,
                value: opt.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[62] || (_cache[62] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, " 定时发送时间 ", -1)), _createVNode(_component_el_date_picker, {
            modelValue: formData.scheduleTime,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => formData.scheduleTime = $event),
            type: "datetime",
            format: "YYYY年MM月DD日 HH:mm",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            placeholder: "请选择发送时间",
            class: "w-full form-date"
          }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_49, [_createElementVNode("label", _hoisted_50, [_withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => formData.publishNow = $event),
            class: "form-switch-input"
          }, null, 512), [[_vModelCheckbox, formData.publishNow]]), _cache[63] || (_cache[63] = _createElementVNode("span", {
            class: "form-switch-track"
          }, null, -1)), _cache[64] || (_cache[64] = _createElementVNode("span", {
            class: "ml-3 text-sm text-slate-700"
          }, "立即发布", -1))]), formData.publishNow ? (_openBlock(), _createBlock(_component_el_text, {
            key: 0,
            type: "success",
            size: "small",
            class: "ml-3"
          }, {
            default: _withCtx(() => [...(_cache[65] || (_cache[65] = [_createTextVNode(" 通知将在保存后立即发布 ", -1)]))]),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_text, {
            key: 1,
            type: "info",
            size: "small",
            class: "ml-3"
          }, {
            default: _withCtx(() => [...(_cache[66] || (_cache[66] = [_createTextVNode(" 通知将保存为草稿，需手动发布 ", -1)]))]),
            _: 1
          }))]), formData.targetType !== 'ALL_USER' ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_createElementVNode("h4", _hoisted_52, "选择 " + _toDisplayString(getTargetTypeLabel(formData.targetType)), 1), formData.targetType === 'TENANT' ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_createVNode(FranchiseeSelector, {
            modelValue: formData.tenantIds,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => formData.tenantIds = $event),
            multiple: "",
            placeholder: "请选择加盟商"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), formData.targetType === 'ROLE' ? (_openBlock(), _createElementBlock("div", _hoisted_54, [_createVNode(RoleSelector, {
            modelValue: formData.roleIds,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => formData.roleIds = $event),
            multiple: "",
            placeholder: "请选择角色"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), formData.targetType === 'DEPT' ? (_openBlock(), _createElementBlock("div", _hoisted_55, [_createVNode(DeptSelector, {
            modelValue: formData.deptIds,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => formData.deptIds = $event),
            multiple: "",
            placeholder: "请选择部门"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), formData.targetType === 'USER_LIST' ? (_openBlock(), _createElementBlock("div", _hoisted_56, [_createVNode(UserSelector, {
            modelValue: formData.userIds,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => formData.userIds = $event),
            multiple: "",
            placeholder: "请选择用户"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), getSelectedCount() === 0 ? (_openBlock(), _createBlock(_component_el_text, {
            key: 4,
            type: "warning",
            size: "small"
          }, {
            default: _withCtx(() => [_createTextVNode(" 请至少选择一个" + _toDisplayString(getTargetTypeLabel(formData.targetType)), 1)]),
            _: 1
          })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_57, [_cache[72] || (_cache[72] = _createElementVNode("h4", {
            class: "text-sm font-medium text-slate-700 mb-3"
          }, "跳转配置", -1)), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", null, [_cache[67] || (_cache[67] = _createElementVNode("label", {
            class: "block text-xs font-medium text-slate-700 mb-1"
          }, "跳转类型", -1)), _createVNode(_component_el_select, {
            modelValue: formData.link.linkType,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => formData.link.linkType = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "无跳转",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "订单详情",
              value: "ORDER"
            }), _createVNode(_component_el_option, {
              label: "审批详情",
              value: "APPROVAL"
            }), _createVNode(_component_el_option, {
              label: "客户详情",
              value: "CUSTOMER"
            }), _createVNode(_component_el_option, {
              label: "合同详情",
              value: "CONTRACT"
            }), _createVNode(_component_el_option, {
              label: "日程详情",
              value: "SCHEDULE"
            }), _createVNode(_component_el_option, {
              label: "待办事项",
              value: "TODO"
            }), _createVNode(_component_el_option, {
              label: "表单页面",
              value: "FORM"
            }), _createVNode(_component_el_option, {
              label: "外部链接",
              value: "WEB_URL"
            }), _createVNode(_component_el_option, {
              label: "自定义页面",
              value: "CUSTOM"
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[68] || (_cache[68] = _createElementVNode("label", {
            class: "block text-xs font-medium text-slate-700 mb-1"
          }, "业务ID", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => formData.link.businessId = $event),
            type: "text",
            placeholder: "请输入业务ID",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, formData.link.businessId]])])]), formData.link.linkType === 'WEB_URL' ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_cache[69] || (_cache[69] = _createElementVNode("label", {
            class: "block text-xs font-medium text-slate-700 mb-1"
          }, "完整URL", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => formData.link.webUrl = $event),
            type: "text",
            placeholder: "https://example.com",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, formData.link.webUrl]])])) : _createCommentVNode("", true), formData.link.linkType && formData.link.linkType !== 'WEB_URL' ? (_openBlock(), _createElementBlock("div", _hoisted_60, [_createElementVNode("label", _hoisted_61, [_withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => formData.link.webNewWindow = $event),
            class: "form-switch-input"
          }, null, 512), [[_vModelCheckbox, formData.link.webNewWindow]]), _cache[70] || (_cache[70] = _createElementVNode("span", {
            class: "form-switch-track"
          }, null, -1)), _cache[71] || (_cache[71] = _createElementVNode("span", {
            class: "ml-3 text-sm text-slate-700"
          }, "新窗口打开", -1))])])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_62, [_createElementVNode("button", {
            onClick: closeModal,
            class: "btn-secondary"
          }, " 取消 "), _createElementVNode("button", {
            onClick: handleSave,
            disabled: saving.value,
            class: "btn-primary"
          }, _toDisplayString(saving.value ? '保存中...' : isEdit.value ? '保存' : '发布'), 9, _hoisted_63)])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showDetailModal.value,
          size: "2xl",
          scrollable: false,
          onClose: _cache[26] || (_cache[26] = $event => showDetailModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_64, [_cache[74] || (_cache[74] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "通知详情", -1)), _createElementVNode("button", {
            onClick: _cache[24] || (_cache[24] = $event => showDetailModal.value = false),
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
          }, [...(_cache[73] || (_cache[73] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_createElementVNode("span", {
            class: _normalizeClass(["inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium", getTypeClass(currentDetail.value?.type)])
          }, _toDisplayString(currentDetail.value?.typeDesc || getTypeLabel(currentDetail.value?.type)), 3), _createElementVNode("span", {
            class: _normalizeClass(["status-badge", getPriorityClass(currentDetail.value?.priority)])
          }, _toDisplayString(currentDetail.value?.priorityDesc || getPriorityLabel(currentDetail.value?.priority)), 3), _createElementVNode("span", {
            class: _normalizeClass(["status-badge", currentDetail.value?.publishStatus === 'PUBLISHED' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'])
          }, _toDisplayString(currentDetail.value?.publishStatusDesc), 3)]), _createElementVNode("div", null, [_createElementVNode("h4", _hoisted_68, _toDisplayString(currentDetail.value?.title), 1), _createElementVNode("p", _hoisted_69, _toDisplayString(currentDetail.value?.summary), 1)]), _createElementVNode("div", _hoisted_70, [_cache[75] || (_cache[75] = _createElementVNode("h5", {
            class: "text-sm font-medium text-slate-700 mb-2"
          }, "通知内容", -1)), _unref(isHtmlContent)(currentDetail.value?.content) ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_71, null, 512)), [[_directive_safe_html, currentDetail.value.content]]) : (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(currentDetail.value?.content), 1))]), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", null, [_cache[76] || (_cache[76] = _createElementVNode("span", {
            class: "text-sm text-slate-500"
          }, "发送时间", -1)), _createElementVNode("p", _hoisted_74, _toDisplayString(currentDetail.value?.sentTime || (currentDetail.value?.scheduleTime ? `定时: ${currentDetail.value.scheduleTime}` : '-')), 1)]), _createElementVNode("div", null, [_cache[77] || (_cache[77] = _createElementVNode("span", {
            class: "text-sm text-slate-500"
          }, "创建时间", -1)), _createElementVNode("p", _hoisted_75, _toDisplayString(currentDetail.value?.createTime || '-'), 1)]), _createElementVNode("div", null, [_cache[78] || (_cache[78] = _createElementVNode("span", {
            class: "text-sm text-slate-500"
          }, "接收人数", -1)), _createElementVNode("p", _hoisted_76, _toDisplayString(currentDetail.value?.totalReceivers || 0), 1)]), _createElementVNode("div", null, [_cache[79] || (_cache[79] = _createElementVNode("span", {
            class: "text-sm text-slate-500"
          }, "已读人数", -1)), _createElementVNode("p", _hoisted_77, _toDisplayString(currentDetail.value?.readCount || 0) + " (" + _toDisplayString(currentDetail.value?.readRate || 0) + "%)", 1)])]), currentDetail.value?.linkType && currentDetail.value.linkType !== 'NONE' ? (_openBlock(), _createElementBlock("div", _hoisted_78, [_cache[80] || (_cache[80] = _createElementVNode("h5", {
            class: "text-sm font-medium text-slate-700 mb-2"
          }, "跳转配置", -1)), _createElementVNode("div", _hoisted_79, [_createElementVNode("p", null, "跳转类型：" + _toDisplayString(currentDetail.value.linkType), 1), currentDetail.value.businessId ? (_openBlock(), _createElementBlock("p", _hoisted_80, "业务ID：" + _toDisplayString(currentDetail.value.businessId), 1)) : _createCommentVNode("", true), currentDetail.value.webPath ? (_openBlock(), _createElementBlock("p", _hoisted_81, "Web路径：" + _toDisplayString(currentDetail.value.webPath), 1)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_82, [_createElementVNode("button", {
            onClick: _cache[25] || (_cache[25] = $event => showDetailModal.value = false),
            class: "btn-secondary"
          }, " 关闭 ")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showPublishModal.value,
          size: "md",
          "panel-class": "p-6 mx-4",
          onClose: _cache[33] || (_cache[33] = $event => showPublishModal.value = false)
        }, {
          default: _withCtx(() => [_cache[86] || (_cache[86] = _createElementVNode("div", {
            class: "flex items-center gap-4 mb-4"
          }, [_createElementVNode("div", {
            class: "w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center"
          }, [_createElementVNode("svg", {
            class: "w-6 h-6 text-blue-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          })])]), _createElementVNode("div", null, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "发布通知"), _createElementVNode("p", {
            class: "text-sm text-slate-500"
          }, "确定要发布该通知吗？发布后将无法修改和删除。")])], -1)), _createElementVNode("div", _hoisted_83, [_cache[81] || (_cache[81] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "目标用户", -1)), _createVNode(_component_el_select, {
            modelValue: publishTarget.targetType,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => publishTarget.targetType = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(targetTypeOptions, opt => {
              return _createVNode(_component_el_option, {
                key: opt.value,
                label: opt.label,
                value: opt.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue"])]), publishTarget.targetType !== 'ALL_USER' ? (_openBlock(), _createElementBlock("div", _hoisted_84, [_createElementVNode("label", _hoisted_85, " 选择 " + _toDisplayString(getTargetTypeLabel(publishTarget.targetType)), 1), publishTarget.targetType === 'TENANT' ? (_openBlock(), _createElementBlock("div", _hoisted_86, [_createVNode(FranchiseeSelector, {
            modelValue: publishTarget.tenantIds,
            "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => publishTarget.tenantIds = $event),
            multiple: "",
            placeholder: "请选择加盟商"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), publishTarget.targetType === 'ROLE' ? (_openBlock(), _createElementBlock("div", _hoisted_87, [_createVNode(RoleSelector, {
            modelValue: publishTarget.roleIds,
            "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => publishTarget.roleIds = $event),
            multiple: "",
            placeholder: "请选择角色"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), publishTarget.targetType === 'DEPT' ? (_openBlock(), _createElementBlock("div", _hoisted_88, [_createVNode(DeptSelector, {
            modelValue: publishTarget.deptIds,
            "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => publishTarget.deptIds = $event),
            multiple: "",
            placeholder: "请选择部门"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), publishTarget.targetType === 'USER_LIST' ? (_openBlock(), _createElementBlock("div", _hoisted_89, [_createVNode(UserSelector, {
            modelValue: publishTarget.userIds,
            "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => publishTarget.userIds = $event),
            multiple: "",
            placeholder: "请选择用户"
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), publishTarget.targetType === 'TENANT' && (!publishTarget.tenantIds || publishTarget.tenantIds.length === 0) ? (_openBlock(), _createBlock(_component_el_text, {
            key: 4,
            type: "warning",
            size: "small"
          }, {
            default: _withCtx(() => [...(_cache[82] || (_cache[82] = [_createTextVNode(" 请至少选择一个加盟商 ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true), publishTarget.targetType === 'ROLE' && (!publishTarget.roleIds || publishTarget.roleIds.length === 0) ? (_openBlock(), _createBlock(_component_el_text, {
            key: 5,
            type: "warning",
            size: "small"
          }, {
            default: _withCtx(() => [...(_cache[83] || (_cache[83] = [_createTextVNode(" 请至少选择一个角色 ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true), publishTarget.targetType === 'DEPT' && (!publishTarget.deptIds || publishTarget.deptIds.length === 0) ? (_openBlock(), _createBlock(_component_el_text, {
            key: 6,
            type: "warning",
            size: "small"
          }, {
            default: _withCtx(() => [...(_cache[84] || (_cache[84] = [_createTextVNode(" 请至少选择一个部门 ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true), publishTarget.targetType === 'USER_LIST' && (!publishTarget.userIds || publishTarget.userIds.length === 0) ? (_openBlock(), _createBlock(_component_el_text, {
            key: 7,
            type: "warning",
            size: "small"
          }, {
            default: _withCtx(() => [...(_cache[85] || (_cache[85] = [_createTextVNode(" 请至少选择一个用户 ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_90, [_createElementVNode("button", {
            onClick: _cache[32] || (_cache[32] = $event => showPublishModal.value = false),
            class: "btn-secondary"
          }, " 取消 "), _createElementVNode("button", {
            onClick: confirmPublish,
            disabled: publishing.value,
            class: "btn-primary"
          }, _toDisplayString(publishing.value ? '发布中...' : '确认发布'), 9, _hoisted_91)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      });
    };
  }
};